<script setup>
import { isVNode, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import Policy from 'dashboard/components/policy.vue';
import { useSidebarContext } from './provider';
import {
  SIDEBAR_MENU_ITEM_ACTIVE_BG,
  SIDEBAR_MENU_ITEM_ACTIVE_TEXT,
  SIDEBAR_MENU_ITEM_INACTIVE,
  SIDEBAR_SUBMENU_ITEM_BASE,
  SIDEBAR_MENU_ICON_ACTIVE,
  SIDEBAR_MENU_ICON_INACTIVE,
} from './sidebarMenuItemClasses';

const props = defineProps({
  label: { type: String, required: true },
  to: { type: [String, Object], default: null },
  icon: { type: [String, Object], default: null },
  rightIcon: { type: [String, Object], default: null },
  active: { type: Boolean, default: false },
  component: { type: Function, default: null },
  onClick: { type: Function, default: null },
});

const { resolvePermissions, resolveFeatureFlag } = useSidebarContext();

const shouldRenderComponent = computed(() => {
  return typeof props.component === 'function' || isVNode(props.component);
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Policy
    :permissions="resolvePermissions(to)"
    :feature-flag="resolveFeatureFlag(to)"
    as="li"
    class="relative child-item ltr:ml-6 rtl:mr-6 w-[calc(100%-1.65rem)]"
    :class="[
      { active },
      active
        ? `${SIDEBAR_MENU_ITEM_ACTIVE_BG} before:bg-[var(--sidebar-accent)]`
        : 'before:bg-transparent',
    ]"
  >
    <component
      :is="to ? 'router-link' : 'div'"
      :to="to"
      :title="label"
      class="group"
      :class="[
        SIDEBAR_SUBMENU_ITEM_BASE,
        active
          ? SIDEBAR_MENU_ITEM_ACTIVE_TEXT
          : `${SIDEBAR_MENU_ITEM_INACTIVE} text-n-slate-11`,
      ]"
      @click="onClick"
    >
      <component
        :is="component"
        v-if="shouldRenderComponent"
        :label
        :icon
        :active
      />
      <template v-else>
        <Icon
          v-if="icon"
          :icon="icon"
          class="size-[18px] inline-block"
          :class="
            active ? SIDEBAR_MENU_ICON_ACTIVE : SIDEBAR_MENU_ICON_INACTIVE
          "
        />
        <div class="flex-1 truncate min-w-0">{{ label }}</div>
        <Icon
          v-if="rightIcon"
          :icon="rightIcon"
          class="size-3 inline-block text-n-slate-11"
        />
      </template>
    </component>
  </Policy>
</template>
